import * as React from 'react';
import { flushSync } from 'react-dom';

import { errorClassName } from './InputField';

const useFormErrors = () => {
    const [, rerender] = React.useState<any>();
    const errorsMapRef = React.useRef<string[]>([]);
    const isSubmittedRef = React.useRef(false);

    const errors: string[] = [];

    React.useEffect(() => {
        errorsMapRef.current = errors;
    });

    React.useEffect(() => {
        return () => {
            errorsMapRef.current = [];
        };
    }, []);

    return {
        reset: () => {
            isSubmittedRef.current = false;
            errorsMapRef.current = [];
            rerender({});
        },
        onFormSubmit: (element?: HTMLElement) => {
            isSubmittedRef.current = true;
            if (element) {
                // eslint-disable-next-line @eslint-react/dom-no-flush-sync -- rendu synchrone requis pour focus le premier champ en erreur avant le submit
                flushSync(() => {
                    rerender({});
                });
                element?.querySelector(`.${errorClassName}`)?.scrollIntoView();
            } else {
                rerender({});
            }
            const oldErrors = errorsMapRef.current;
            return !oldErrors.some((value) => !!value);
        },
        validator: (validations: string[]) => {
            const error = validations.reduce((acc, x) => acc || x, '');
            errors.push(error);
            return isSubmittedRef.current ? error : '';
        },
    };
};

export default useFormErrors;
